import React from 'react';
import ContactHero from '../components/ContactHero';
import ContactGridForm from '../components/ContactGridForm';

const ContactPage = () => {
  return (
    <div className="gfi-contact-page-wrapper">
      
      {/* 1. TOP WIDE RUNNING HERO BANNER BLOCK */}
      <ContactHero />
         <ContactGridForm />
      
      {/* 2. Contact Grid Details, Lead Forms & Map Locations Yahan Par Add Honge */}

    </div>
  );
};

export default ContactPage;